import { Link } from "react-router-dom";

export default function Logo({ className = "" }) {
  return (
    <Link to="/" data-testid="brand-logo" className={`inline-flex items-center gap-2 group ${className}`}>
      <span className="relative inline-flex h-8 w-8 items-center justify-center rounded-lg bg-[#F26953] shadow-sm">
        <svg viewBox="0 0 24 24" className="h-4 w-4 text-white" fill="currentColor">
          <path d="M2 6.5A2.5 2.5 0 0 1 4.5 4h15A2.5 2.5 0 0 1 22 6.5v11A2.5 2.5 0 0 1 19.5 20h-15A2.5 2.5 0 0 1 2 17.5v-11Zm2.6.4 7.4 5.2 7.4-5.2A.5.5 0 0 0 19 6H5a.5.5 0 0 0-.4.9Z"/>
        </svg>
      </span>
      <span className="font-[Outfit] text-lg font-bold tracking-tight text-[#0F172A]">
        oly <span className="text-[#F26953]">Inbox</span>
      </span>
    </Link>
  );
}
